export default __webpack_public_path__ + "static/media/Blackburn_LE.46071059.jpg";